/** Optional synchronous observers for reversible application brush commands. */
type Observer = { begin(imageId: string): void; beforeVoxel(imageId: string, i: number, j: number, k: number): void | boolean; end(imageId: string): void };
const observers = new Set<Observer>();
export function observePaintStrokes(observer: Observer) { observers.add(observer); return () => observers.delete(observer); }
export const paintStrokeEvents = {
  begin: (imageId: string) => observers.forEach(o => o.begin(imageId)),
  beforeVoxel: (imageId: string, i: number, j: number, k: number) => {
    for (const observer of observers) if (observer.beforeVoxel(imageId, i, j, k) === false) return false;
    return true;
  },
  end: (imageId: string) => observers.forEach(o => o.end(imageId)),
};
